module.exports = __webpack_public_path__ + "img/thumb-joe-off.99e92f46.jpg";